export const searchColumn = [
  {
    type: 'input',
    prop: 'ma_code',
    label: ' MA Code',
    placeholder: 'Search..',
  },
  {
    type: 'input',
    prop: 'zone_code',
    label: 'Zone Code',
    placeholder: 'Search..',
  },
  {
    type: 'select',
    prop: 'province',
    label: 'Province',
    option_label:'code',
    option_value:"code",
    placeholder: 'Search..',
    options: [
    ]
  },
  {
    type: 'input',
    prop: 'included_postal_codes',
    label: 'Include Pc',
    placeholder: 'Search..',
  }
]
